import React from 'react';

import AtlassianTextField from '@qality/common-components/src/atoms/atlaskit/TextField';

import { TextFieldIconStyled, TextFieldStyled } from './TextField.styled';

export const TextField = ({ suffixComponent, ...props }: any) => (
  <TextFieldStyled hasSuffix={!!suffixComponent}>
    <AtlassianTextField {...props} />
    {suffixComponent && (
      <TextFieldIconStyled>{suffixComponent}</TextFieldIconStyled>
    )}
  </TextFieldStyled>
);
